export const widgetHeightTypes = {
  NORMAL: 1,
  DOUBLE: 2,
};
